const React = require('react');
const { Outlet, useRouteError, isRouteErrorResponse } = require('react-router-dom');
const styled = require('@emotion/styled').default;

const Container = styled('div')`
    max-width: 1200px;
    margin: 60px auto  0;
    text-align: left;
    @media (max-width: 768px) { margin: 20px auto 0; padding: 0 16px; }
`;

const RootLayout = () => (
    <Container className='challenge-container'>
        <Outlet/>
    </Container>
    // <div className='challenge-container'>
    //     <Outlet/>
    // </div>
    
);

const ErrorBoundary = () => {
    const error = useRouteError();
    const code = isRouteErrorResponse(error) ? error.status: 500;
    return (
        <div style={{ textAlign: 'center'}}>
            <div style={{ fontSize: `4rem`, fontWeight: 300}}>{code}</div>
            <div style={{ color: '#666'}}>Something went wrong.</div>
        </div>
    );
}

RootLayout.ErrorBoundary = ErrorBoundary;

module.exports = RootLayout;